import React, { useState } from 'react';
import { Typography } from '@mui/material';
import TextInputBox from '../../components/TextInputBox';
import { LOGIN_RESETSUCCESS } from '../../constants';
import ButtonBox from '../../components/ButtonBox';
import '../../style/Login.css';

interface ResetPasswordProps {
    setLoginPage: React.Dispatch<React.SetStateAction<string>>;
}

const ResetPassword: React.FC<ResetPasswordProps> = ({ setLoginPage }) => {
    const [formValues, setFormValues] = useState({
        password: '',
        confirmPassword: '',
    });

    const handleChange = (field: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormValues((prevValues) => ({ ...prevValues, [field]: e.target.value }));
    };

    const handleResetPassword = (e: React.FormEvent) => {
        setLoginPage(LOGIN_RESETSUCCESS);
    };

    return (
        <>
            <Typography className='login_typography_title'>
                Reset Password
            </Typography>

            <TextInputBox
                label="Password"
                value={formValues.password}
                onChange={handleChange('password')}
                placeholder="At least 8 characters"
                type="password"
            />

            <TextInputBox
                label="Confirm password"
                value={formValues.confirmPassword}
                onChange={handleChange('confirmPassword')}
                placeholder="At least 8 characters"
                type="password"
            />

            <ButtonBox
                text="Reset"
                onClick={handleResetPassword}
            />


        </>
    );
};

export default ResetPassword;
